import { render } from "./TrainingLayout.vue?vue&type=template&id=ca4e28c4&scoped=true"
import script from "./TrainingLayout.vue?vue&type=script&lang=js"
export * from "./TrainingLayout.vue?vue&type=script&lang=js"

import "./TrainingLayout.vue?vue&type=style&index=0&id=ca4e28c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4e28c4"]])

export default __exports__